import React from 'react'

const RightArrowIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.89602 5.5L7.60352 6.7925L11.8018 11L7.60352 15.2075L8.89602 16.5L14.396 11L8.89602 5.5Z"
        fill="#282725"
      />
    </svg>
  )
}

export default RightArrowIcon
